export default "__VITE_ASSET__G81KrSRr__"